import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';
import { ShareModalProps } from './share-modal-context';
import { memo } from 'react';

const ShareModal = lazyComponent<ShareModalProps>(() =>
  import('./share-modal').then((mod) => mod.ShareModal),
);

export const ShareModalLazy: React.FC = () => <ShareModal />;

export default memo(ShareModalLazy);
